import * as React from "react";

import ensureArray from "./ensureArray";

type KeyboardEventType = React.KeyboardEvent<EventTarget>;

// use this function in conjunction with any key event to create handlers for specific keys.
export function createKeyHandler(
  keys: string | Array<string>,
  onKey: (e: KeyboardEventType) => any
): React.KeyboardEventHandler<HTMLElement> {
  return function (e: React.KeyboardEvent<HTMLElement>) {
    const keysArray = ensureArray(keys);

    const hasAnyMatchingKeys = keysArray.some((key: string) => e.key === key);

    if (hasAnyMatchingKeys) {
      onKey(e);
    }
  };
}
